import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AppleIcon, SmartphoneIcon } from 'lucide-react';
import { PhoneMockup } from './PhoneMockup';
export function Hero() {
  return <section className="relative min-h-screen pt-32 pb-20 px-6 overflow-hidden bg-gradient-to-br from-orange-50 via-white to-orange-50" data-id="element-74">
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-orange-200 rounded-full blur-3xl opacity-30" data-id="element-75"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-300 rounded-full blur-3xl opacity-20" data-id="element-76"></div>

      {/* Dot grid decoration */}
      <div className="absolute top-40 left-20 grid grid-cols-3 gap-2 opacity-40" data-id="element-77">
        {[...Array(9)].map((_, i) => <div key={i} className="w-1.5 h-1.5 bg-orange-400 rounded-full" data-id="element-78"></div>)}
      </div>

      <div className="relative max-w-7xl mx-auto" data-id="element-79">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-80">
          {/* Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-81">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6" style={{
            fontFamily: 'DM Serif Display, serif'
          }} data-id="element-82">
              Your family,{' '}
              <span className="text-orange-500" data-id="element-83">perfectly in sync</span>
            </h1>

            <p className="text-xl text-gray-600 mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-84">
              Keep everyone connected with shared calendars, to-dos, memories,
              and instant updates — all in one beautiful app.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-85">
              <button className="bg-gray-900 text-white px-8 py-4 rounded-2xl font-semibold hover:bg-gray-800 transition-all hover:scale-105 flex items-center justify-center gap-3 shadow-lg" data-id="element-86">
                <AppleIcon className="w-6 h-6" data-id="element-87" />
                <div className="text-left" data-id="element-88">
                  <div className="text-xs opacity-80" data-id="element-89">Download on the</div>
                  <div className="text-lg font-bold" data-id="element-90">App Store</div>
                </div>
              </button>

              <div className="bg-gray-100 border-2 border-gray-200 text-gray-400 px-8 py-4 rounded-2xl flex items-center justify-center gap-3 cursor-default" data-id="element-91">
                <SmartphoneIcon className="w-6 h-6" data-id="element-92" />
                <div className="text-left" data-id="element-93">
                  <div className="text-xs opacity-80" data-id="element-94">Google Play</div>
                  <div className="text-lg font-semibold" data-id="element-95">Coming Soon</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Hero phone mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-96">
            {/* Sparkle decoration */}
            <div className="absolute -top-10 -right-10 text-orange-400 text-6xl" data-id="element-97">
              ✦
            </div>
            <PhoneMockup imageUrl="https://cdn.magicpatterns.com/uploads/5ZBmk26BubsdyadAN5MyVc/calendar-1.png" alt="Famday Calendar App" data-id="element-98" />
          </motion.div>
        </div>
      </div>
    </section>;
}